module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticStyle: {
      "margin": "0% -110% 0% 27%"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.remarks),
      expression: "remarks",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "id": "narration1",
      "cols": "15",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0% 0% 0% 8%"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "type": "submit",
      "id": "action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTO.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s('Add'))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-left",
    staticStyle: {
      "margin": "0% 0% 0.5% 1%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset()
      }
    }
  }, [_vm._v("Re-set")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-left",
    staticStyle: {
      "margin": "0% 0% 0% 18%"
    },
    attrs: {
      "type": "submit",
      "id": "action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportToPdf()
      }
    }
  }, [_vm._v("\n                " + _vm._s('Print'))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-left",
    staticStyle: {
      "margin": "0% 0% 0% 1%"
    },
    attrs: {
      "type": "submit",
      "id": "action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPrint()
      }
    }
  }, [_vm._v("\n                " + _vm._s('Rest Print'))])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.printLists), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks))])])])
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Renarks")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de5d1d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/printPages/arbPrint.vue
// module id = 2297
// module chunks = 0